<template>
  <v-app>
    <v-container fluid>
      <v-row>
        <!-- Left Panel: Production Info -->
        <v-col md="3" cols="12">
          <v-expansion-panels v-model="panel">
            <v-expansion-panel>
              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Production Info
              </v-expansion-panel-title>

              <v-expansion-panel-text>
                <v-row>

                  <v-col cols="12">
                    <v-autocomplete
                      label="Production Type"
                      v-model="type"
                      :items="productionType"
                      item-title="label"
                      item-value="value"
                      density="compact"
                      variant="outlined"
                      clearable
                      hide-details
                      @update:model-value="changeType"
                    />
                  </v-col>

                  <v-col cols="12" v-if="!isBulkRequisition">
                    <v-autocomplete
                      label="Sale Orders"
                      v-model="sale_order_master_id"
                      :items="pendingSaleOrderListForProduction"
                      item-title="code"
                      item-value="id"
                      density="compact"
                      variant="outlined"
                      clearable
                      hide-details
                      @update:model-value="changeSaleOrder"
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-date-input
                      label="Production Date"
                      v-model="production_date"
                      variant="outlined"
                      density="compact"
                      clearable
                      prepend-icon=""
                      hide-details
                    />
                  </v-col>

                  <v-col cols="12">
                    <v-textarea
                      label="Remarks"
                      v-model="remarks"
                      density="compact"
                      variant="outlined"
                      clearable
                    />
                  </v-col>

                </v-row>
              </v-expansion-panel-text>

            </v-expansion-panel>
          </v-expansion-panels>
        </v-col>

        <!-- Right Panel: Production Details -->
        <v-col md="9" cols="12">

          <v-expansion-panels v-model="panel2">
            <v-expansion-panel>

              <v-expansion-panel-title
                color="blue-grey-lighten-4"
                class="panel-header"
              >
                Production Details
              </v-expansion-panel-title>

              <v-expansion-panel-text>

                <v-row v-if="isBulkRequisition" class="pt-2 justify-center">
                  <v-col cols="8">
                    <v-autocomplete
                      label="Search Product Name"
                      variant="outlined"
                      density="compact"
                      bg-color="grey-lighten-4"
                      v-model="product_id.value.value"
                      :items="getProductMapList"
                      :item-title="(item) => `${item.product.code}-${item.product.name}` ?? 'N/A'"
                      item-value="product_id"
                      @update:model-value="addCart"
                      @keydown.enter="addCart"
                      autocomplete="off"
                      clearable
                    />
                  </v-col>
                </v-row>

                <v-row class="pt-0">
                  <v-col cols="12">

                    <v-table density="compact" :loading="loading" fixed-header class="table-dotted-border-bottom">

                      <thead>
                        <tr>
                          <th class="text-center" style="width: 5%">SL</th>
                          <th class="text-center" style="width: 10%">Code</th>
                          <th class="text-left" style="width: 25%">Product Name</th>
                          <th class="text-center" style="width: 10%">Unit</th>
                          <th class="text-left" style="width: 15%">Quantity</th>
                          <th class="text-left" style="width: 15%">Other Cost</th>
                          <th class="text-right" style="width: 5%">Action</th>
                        </tr>
                      </thead>

                      <tbody>

                        <template v-for="(item, index) in cart" :key="index">

                          <tr
                            @click="toggleRow(index)"
                            style="cursor: pointer; background: #0000003B;"
                          >
                            <td class="text-center py-1">{{ index + 1 }}</td>

                            <td class="text-left py-1">
                              {{ item.product_code }}
                            </td>

                            <td class="text-left py-1">
                              {{ item.product_name }}
                            </td>

                            <td class="text-center py-1">
                              {{ item.unit_name }}
                            </td>

                            <td class="text-left py-1">

                              <v-text-field
                                type="number"
                                density="compact"
                                variant="outlined"
                                style="width: 80px"
                                v-model="item.quantity"
                                hide-details
                                bg-color="grey-lighten-4"
                                @click.stop
                              />

                            </td>

                            <td class="text-left py-1">

                              <v-text-field
                                type="number"
                                density="compact"
                                variant="outlined"
                                style="width: 100px"
                                v-model="item.other_unit_cost"
                                hide-details
                                bg-color="grey-lighten-4"
                                @click.stop
                              />

                            </td>

                            <td class="text-center py-1">
                              <v-btn
                                icon
                                color="red"
                                variant="tonal"
                                @click.stop="removeRow(index)"
                              >
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </td>

                          </tr>


                          <!-- Expandable Row -->

                          <tr v-if="expandedRow === index">
                            <td colspan="7" class="pa-5 bg-grey-lighten-4">

                              <v-expand-transition>

                                <div v-if="item.template_items">

                                  <v-table density="compact" fixed-header class="table-dotted-border-bottom">

                                    <thead>
                                      <tr>
                                        <th class="text-center" style="width: 5%">SL</th>
                                        <th class="text-center" style="width: 10%">Code</th>
                                        <th class="text-left" style="width: 20%">Raw Product Name</th>
                                        <th class="text-center" style="width: 10%">Unit</th>
                                        <th class="text-left" style="width: 10%">Qty</th>
                                        <th class="text-left" style="width: 10%">Total Qty</th>
                                        <th class="text-left" style="width: 20%">Process Loss %</th>
                                        <th class="text-left" style="width: 10%">Loss Qty</th>
                                      </tr>
                                    </thead>

                                    <tbody>

                                      <tr v-for="(templateItem, rawIndex) in item.template_items" :key="rawIndex">

                                        <td class="text-center py-1">
                                          {{ rawIndex + 1 }}
                                        </td>

                                        <td class="text-left py-1">
                                          {{ templateItem?.raw_product?.code }}
                                        </td>

                                        <td class="text-left py-1">
                                          {{ templateItem?.raw_product?.name }}
                                        </td>

                                        <td class="text-center py-1">
                                          {{ templateItem?.raw_product?.unit?.name }}
                                        </td>

                                        <td class="text-left py-1">
                                          {{ templateItem.quantity }}
                                        </td>

                                        <td class="text-left py-1">
                                          {{ templateItem.quantity * item.quantity }}
                                        </td>

                                        <td class="text-left py-1">
                                          {{ templateItem.process_loss_percent }}
                                        </td>

                                        <td class="text-left py-1">
                                          {{
                                            ((templateItem.quantity * item.quantity) *
                                            (templateItem.process_loss_percent / 100)).toFixed(2)
                                          }}
                                        </td>

                                      </tr>

                                    </tbody>

                                  </v-table>

                                </div>

                              </v-expand-transition>

                            </td>
                          </tr>

                        </template>


                        <tr v-if="cart.length === 0 && !loading">
                          <td colspan="7" class="text-center text-red">
                            You have no item
                          </td>
                        </tr>

                      </tbody>

                    </v-table>

                  </v-col>
                </v-row>

                <v-divider class="my-2"></v-divider>

                <v-card-actions>
                  <v-row class="pt-2">
                    <v-col cols="8"></v-col>

                    <v-col cols="4" class="d-flex justify-end">

                      <v-btn
                        class="bg-grey-darken-1 me-2"
                        variant="flat"
                        :loading="loading"
                        @click="submitProduction(0)"
                      >
                        Draft
                      </v-btn>

                      <v-btn
                        class="bg-primary"
                        variant="flat"
                        :loading="loading"
                        @click="submitProduction(1)"
                      >
                        {{ isEdit ? "Update" : "Save" }}
                      </v-btn>

                    </v-col>

                  </v-row>
                </v-card-actions>

              </v-expansion-panel-text>

            </v-expansion-panel>
          </v-expansion-panels>

        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script setup>

import { ref, computed, onMounted, nextTick } from "vue";
import { useStore } from "vuex";
import { toast } from "vue3-toastify";
import { useRouter, useRoute } from "vue-router";
import { useField } from "vee-validate";

const router = useRouter();
const route = useRoute();
const store = useStore();

const panel = ref([0]);
const panel2 = ref([0]);

const isEdit = ref(false);
const loading = ref(false);
const productionId = ref(null);

const type = ref("bulk");
const sale_order_master_id = ref(null);
const production_date = ref(null);
const remarks = ref("");

const cart = ref([]);
const expandedRow = ref(null);

const product_id = useField("product_id");
const isBulkRequisition = ref(true);

const productionType = [
  { value: "bulk", label: "Bulk" },
  { value: "sale_order", label: "Sale Order" },
];

const getProductMapList = computed(() => store.getters.getProductMapList || []);
const pendingSaleOrderListForProduction = ref([])

const toggleRow = (index) => {
  expandedRow.value = expandedRow.value === index ? null : index;
};

const removeRow = (index) => cart.value.splice(index, 1);

const loadData = async () => {
  await store.dispatch("getProductMapList");
  await store.dispatch("getPendingSaleOrderListForProduction", { production_status: "Ongoing" });
};

function changeType(){
  if(type.value == 'bulk') isBulkRequisition.value = true;
  if(type.value == 'sale_order') isBulkRequisition.value = false;
  cart.value = [];
}

function addCart(){

  let product = getProductMapList.value.find(
      (item) => item.id == product_id.value.value
  );

  product = product.product;

  let item = {
      product_id: product_id.value.value,
      product_name: product.name,
      product_code: product.code,
      unit_name: product.unit?.name,
      quantity: 1,
      other_unit_cost: 0,
      template_items: product.template?.items
  };

  cart.value.push(item);

  nextTick(() => { product_id.value.value = null; });
}

function changeSaleOrder(){

  const order = pendingSaleOrderListForProduction.value.find(
      item => item.id == sale_order_master_id.value
  );

  if(!order) return;

  cart.value = order.details.map(item => ({
      product_id: item.product_id,
      product_name: item.product?.name,
      product_code: item.product?.code,
      unit_name: item.product?.unit?.name,
      quantity: item.quantity,
      other_unit_cost: 0,
      template_items: item.product?.template?.items
  }));

}

const submitProduction = async (status) => {

  loading.value = true;

  const payload = {
      id: isEdit.value ? productionId.value : null,
      type: type.value,
      sale_order_master_id: sale_order_master_id.value,
      production_date: production_date.value,
      remarks: remarks.value,
      status,
      cart: cart.value.map((item) => ({
          product_id: item.product_id,
          quantity: item.quantity,
          other_unit_cost: item.other_unit_cost,
      })),
  };

  try {

      if (isEdit.value) {
          await store.dispatch("updatePrdProduction", payload);
          toast.success("Updated successfully");
      } else {
          await store.dispatch("savePrdProduction", payload);
          toast.success("Saved successfully");
      }

      router.push({ name: "production-list" });

  } catch (error) {

      console.error(error);
      if(error.response && error.response.data && error.response.data.message) {
          toast.error(error.response.data.message);
      } else {
          toast.error("Something went wrong!");
      }

  } finally {

      loading.value = false;

  }

};

const loadProduction = async (id) => {

  try {

      const response = await store.dispatch("getPrdProductionById", id);
      const data = response.data;

      pendingSaleOrderListForProduction.value = [data.sale_order];

      type.value = data.type;
      sale_order_master_id.value = data.sale_order_master_id;
      production_date.value = data.production_date;
      remarks.value = data.remarks;

      isBulkRequisition.value = type.value === 'bulk';

      cart.value = data.details.map(item => ({
          product_id: item.product_id,
          product_name: item.product?.name,
          product_code: item.product?.code,
          unit_name: item.product?.unit?.name,
          quantity: item.quantity,
          other_unit_cost: item.other_unit_cost,
          template_items: item.product?.template?.items,
      }));

  } catch (error) {

      console.error(error);
      toast.error("Failed to load production!");

  }

};

onMounted(async () => {

  loading.value = true;

  await loadData();
  pendingSaleOrderListForProduction.value = computed(() => store.getters.getPendingSaleOrderListForProduction || []);

  if(route.query.id) {

      productionId.value = route.query.id;
      isEdit.value = true;
      await loadProduction(productionId.value);

  }

  loading.value = false;

});
</script>